import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import useScrollToTop from "../../hooks/useScrollToTop";
import BackToTopButton from "../../hooks/BackToTopButton";

const Layout = () => {
  useScrollToTop(); // 👈 Call it here

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Outlet />
      <Footer />
      <BackToTopButton />
    </div>
  );
};

export default Layout;
